import { render, staticRenderFns } from "./DescricaoSugestaoSelectModal.vue?vue&type=template&id=62695234&scoped=true"
import script from "./DescricaoSugestaoSelectModal.vue?vue&type=script&lang=js"
export * from "./DescricaoSugestaoSelectModal.vue?vue&type=script&lang=js"
import style0 from "./DescricaoSugestaoSelectModal.vue?vue&type=style&index=0&id=62695234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62695234",
  null
  
)

export default component.exports